<template>
  <v-card flat dense>
    <v-form ref="form" v-model="valid">
      <v-card-title>
        <v-row dense>
          <v-col cols="6">
            <v-row>
              <v-col>
                <span class="mr-4">
                  {{ $t('ITEM.CREATE') }} {{ $t('BOOKING.RESERVATIONS.ITEM') }}
                </span>
              </v-col>
              <v-col>
                <div class="d-flex justify-space-between align-center">
                  <span class="text-body-2">{{ $t('ITEM.STATUS') }}</span>
                  <booking-reservations-status
                    v-model="reservation.status_id"
                    name="status_id"
                    style="width: 140px"
                    :error-messages="errors.status_id"
                    disabled
                    @change="clearErrorByName('status_id')"
                  />
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <div class="d-flex justify-space-between align-center">
              <v-spacer />
              <v-btn icon @click="cancel">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-subtitle v-if="errorsWithoutForm.length">
        <errors :errors="errorsWithoutForm" />
      </v-card-subtitle>
      <v-card-text>
        <v-row dense>
          <v-col cols="6">
            <booking-reservation-create-form
              v-model="reservation"
              :resource="resource"
              :errors="errors.getAll()"
              @validRequestForm="validRequestForm = $event"
              @update-prop="clearErrorByName($event)"
            />
          </v-col>
          <v-col cols="6">
            <reservation-slot-form
              v-model="reservation"
              :resource="resource"
              :slots="slots"
              :errors="errors.getAll()"
              @getSlots="getSlots"
              @update-prop="clearErrorByName($event)"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-btn outlined depressed color="grey" @click="cancel">
            {{ $t('BUTTON.CANCEL') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary"
            :disabled="!(valid && validRequestForm)"
            @click="create"
          >
            {{ $t('BUTTON.SAVE') }}
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import Errors from '@/modules/_global/_components/Errors';
import BookingReservationCreateForm from '../forms/BookingReservationCreateForm';
import ReservationSlotForm from '../forms/ReservationSlotForm';
import BookingReservationsStatus from '../forms/BookingReservationsStatus.vue';
import { mapActions } from 'vuex';
import { debounce, isEmpty } from 'lodash';
import { INDIVIDUAL } from '@/modules/booking_resources/common/capacity';
const DEBOUNCE_DELAY = 300;

export default {
  name: 'CreateReservation',

  components: {
    Errors,
    BookingReservationCreateForm,
    BookingReservationsStatus,
    ReservationSlotForm
  },

  mixins: [errors],

  props: {
    resource: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      validRequestForm: false,
      valid: false,
      reservation: {},
      slots: []
    };
  },

  computed: {

    errorsWithoutForm() {
      return ['resource_id', '_unexpected']
        .reduce((acc, i) => acc.concat(this.errors.get(i)), [])
        .filter(i => i);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.reservation = {
        capacity_type: this.resource.capacity_type,
        number_of_visitors: this.isIndividual ? this.resource.capacity : null
      };
    });
  },

  methods: {
    ...mapActions('booking_resources', [
      'getBookingResource',
      'getAvailableSlots'
    ]),
    ...mapActions('booking_reservations', ['storeBookingReservation']),

    getSlots: debounce(function debouncedGetSlots(params) {
      if (
        (isEmpty(this.resource) && !this.resource.id) ||
        !this.validRequestForm
      ) {
        return;
      }

      this.getAvailableSlots({ resourceId: this.resource.id, ...params })
        .then(({ data }) => {
          this.slots = data.data;
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }, DEBOUNCE_DELAY),

    cancel() {
      this.$emit('cancel');
    },

    create() {
      const reservation = {
        ...this.reservation,
        resource_id: this.resource.id
      };

      this.storeBookingReservation({ reservation })
        .then(response => {
          this.$emit('created', response.data);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
